import React from 'react';
import PromoCodeFormComponent from '@websky/core/src/PromoCode/Form/PromoCodeForm';
import { useTranslation } from 'react-i18next';
const PromoCodeForm = props => {
    const { t } = useTranslation('PromoCode');
    return React.createElement(PromoCodeFormComponent, Object.assign({}, props, { submitButtonText: t('Apply'), title: t('Apply promo code') }));
};
export default PromoCodeForm;
